var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCallLog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 14") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-98",
    fill: "#63BA3B",
    x: 0,
    y: 0,
    width: 500,
    height: 500,
    rx: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.439458,364.592632 L360.171775,392.030588 C354.542986,397.910149 346.099802,401.829857 338.59475,400.84993 C276.678069,396.930222 218.513915,367.532413 177.236127,325.395554 C135.95834,282.278767 107.814395,221.523295 105,156.848114 C105,148.028772 107.814395,140.189356 113.443184,134.309794 L139.710866,106.871839 C151.906576,94.1327882 172.54547,95.1127152 182.864917,109.81162 L207.256336,141.169283 C215.69952,151.94848 215.69952,166.647384 208.194468,178.406508 L187.555574,208.784244 C184.74118,212.703952 184.74118,218.583514 188.493706,221.523295 L231.647756,271.49957 L279.492464,316.576211 C283.24499,320.495919 287.935647,320.495919 291.688174,317.556138 L320.770251,295.997744 C331.089698,288.158329 346.099802,288.158329 356.419249,296.977671 L386.439458,322.455773 C397.697036,330.295188 398.635167,351.853582 386.439458,364.592632 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.241493,
    y1: 98,
    x2: 423.724672,
    y2: 98,
    id: "Path-8",
    stroke: "#FFFFFF",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.241493,
    y1: 140,
    x2: 423.724672,
    y2: 140,
    id: "Path-8-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 324.5,
    y1: 182.5,
    x2: 423.724672,
    y2: 182,
    id: "Path-8-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCallLog);
export default __webpack_public_path__ + "static/media/icon-call-log.82d12561c5e9b213bcd59923f666703d.svg";
export { ForwardRef as ReactComponent };